<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title"
              >Carteira Macro Região</v-card-title
            >
            <v-card-text class="app-card-content">
              <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
                <v-row>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      v-model="form.identidade"
                      placeholder="Digite seu RG"
                      v-mask="'####################'"
                      label="RG *"
                      :rules="[rules.required]"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      v-model="form.dataNascimento"
                      placeholder="Ex:. 18/02/1996"
                      label="Data de Nascimento *"
                      v-mask="'##/##/####'"
                      :rules="[rules.required]"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col :md="9" :sm="9" :xs="12" cols="12">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :loadRecaptchaScript="true"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                      class="recaptcha"
                    ></vue-recaptcha>
                    <v-input
                      v-model="form.recaptcha"
                      :rules="[rules.required]"
                    ></v-input>
                  </v-col>
                  <v-col :md="3" :sm="3" :xs="12" cols="12">
                    <v-btn depressed block large color="primary" type="submit"
                      >Continuar</v-btn
                    >
                  </v-col>
                </v-row>
              </v-form>
              <div class="loading" v-if="isLoading">
                <v-progress-circular
                  :size="25"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
          <br />
          <div id="resulta-carteira-macroregicao"></div>
          <ResultadoCarteiraMacroRegicao
            :carteiras="carteiras"
            v-if="carteiras"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import { mask } from "vue-the-mask";
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import CarteiraMacroRegiaoService from "@/services/carteiraMacroRegiao.service";
import { delay } from "rxjs/operators";
import { throwError } from "rxjs";
import ResultadoCarteiraMacroRegicao from "@/views/transportes/carteira-macro-regiao/Resultado";

export default {
  metaInfo: {
    title: "Carteira Macro Região - Central de Serviços"
  },
  components: {
    VueRecaptcha,
    ResultadoCarteiraMacroRegicao
  },
  directives: {
    mask
  },
  data: () => ({
    siteKey: VUE_APP_RECAPTCHA_KEY,
    isLoading: false,
    form: {
      identidade: null,
      dataNascimento: null,
      recaptcha: null
    },
    carteiras: null,
    rules: {
      required: value => !!value || "Esse campo deve ser preenchido"
    }
  }),
  methods: {
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.isLoading = true;
        const { identidade, dataNascimento, recaptcha } = this.form;
        CarteiraMacroRegiaoService.login(
          identidade,
          dataNascimento,
          recaptcha
        ).subscribe(
          response => {
            this.isLoading = false;
            this.carteiras = response;
            this.$vuetify.goTo("#resulta-carteira-macroregicao");
            this.expiredRecaptcha();
          },
          error => {
            this.isLoading = false;
            this.carteiras = null;
            this.expiredRecaptcha();
            throwError(error);
          }
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.loading {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  text-align: center;
  .v-progress-circular {
    margin: auto;
  }
}
</style>
